import { styled } from '@linaria/react';

function ColorBox({ hue, sat, lit }) {
  return (
    <BoxWrapper>
      <Box
        style={{ backgroundColor: `hsl(${hue}deg ${sat}% ${lit}%)` }}
      />
      <Channels>
        hsl({hue}deg {sat}% {lit}%)
      </Channels>
    </BoxWrapper>
  );
}

function HSLColorsFromColorFormats() {
  return (
    <Wrapper>
      <ColorBox hue={60} sat={100} lit={50} />
      <ColorBox hue={240} sat={100} lit={50} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: 32px;
  padding: 0 32px;
  justify-content: center;
  width: 100%;
`;

const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 212px;
  width: 250px;
  max-width: 250px;
`;

const Box = styled.div`
  width: 100%;
  min-height: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
`;

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-family: var(--font-family-mono);
  padding: 0px 8px;
`;

export default HSLColorsFromColorFormats;
